import find from 'lodash/find';
import each from 'lodash/each';
import moment from '@g4/moment-utc';
import { OPPONENT_CITY, OPPONENT_NAME, PACKAGE_ID } from './constants';

// Model the show data into Raiders Games
const gameAlreadyPresent = (show, games) => {
  return find(
    games,
    g =>
      g.showConditions[OPPONENT_CITY] === show.showConditions[OPPONENT_CITY] &&
      moment(g['useDate']).isSame(moment(show.useDate)) &&
      g.showConditions[PACKAGE_ID] === show.showConditions[PACKAGE_ID]
  );
};

export const showsToGames = (shows = []) => {
  const stadiumGames = [];

  // Group shows by OPPONENT_CITY, useDate & PACKAGE_ID.
  // This will constitute a Game
  each(shows, show => {
    let gameFound = gameAlreadyPresent(show, stadiumGames);
    if (gameFound) {
      gameFound.quantity += show.quantity;
      gameFound.maxSeatsAvailable =
        show.quantity > gameFound.maxSeatsAvailable
          ? show.quantity
          : gameFound.maxSeatsAvailable;
    } else {
      let game = {};
      game['quantity'] = show.quantity;
      game['showConditions'] = {
        [OPPONENT_CITY]: show.showConditions[OPPONENT_CITY],
        [OPPONENT_NAME]: show.showConditions[OPPONENT_NAME],
        [PACKAGE_ID]: show.showConditions[PACKAGE_ID],
      };
      game.maxSeatsAvailable = show.quantity;
      game['useDate'] = show.useDate;
      stadiumGames.push(game);
    }
  });

  return stadiumGames;
};
